export enum CreateLicenceScreens {
  BASIC_DETAILS = 1,
  ADDITIONAL_DETAILS = 2,
}